export default __webpack_public_path__ + "static/media/Gallery.88c4ec3c.png";